import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { postRefreshToken } from '../../services/Api';
import { useDispatch } from 'react-redux';
import { updateTokenSuccess } from '../../redux/reducers/auth';

const JWTRemainingTime = ({ decode }) => {
    const dispatch = useDispatch();
    const [timeRemaining, setTimeRemaining] = useState(0);

    const calculateRemainingTime = () => {
        const now = moment();
        const expiration = moment.unix(decode.exp);
        const remainingSeconds = expiration.diff(now, 'seconds');
        setTimeRemaining(Math.max(remainingSeconds, 0));
    };

    useEffect(() => {
        calculateRemainingTime();

        const interval = setInterval(() => {
            calculateRemainingTime();
        }, 1000);

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                calculateRemainingTime();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
        // eslint-disable-next-line
    }, [decode]);

    const formatTime = (seconds) => {
        const duration = moment.duration(seconds, 'seconds');
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        const secs = duration.seconds();
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    const handleRefreshToken = () => {
        postRefreshToken()
            .then(({ data }) => {
                const newDecode = JSON.parse(atob(data.split('.')[1]));
                const now = moment();
                const newExpiration = moment.unix(newDecode.exp);
                const newTimeRemaining = newExpiration.diff(now, 'seconds');
                dispatch(updateTokenSuccess({ newToken: data }));
                setTimeRemaining(newTimeRemaining);
            })
            .catch((error) => console.log(error));
    };

    return (
        <div className="time-count-down-wrap">
            <span>이용시간: </span>
            <p>{formatTime(timeRemaining)}</p>
            <button onClick={handleRefreshToken}>연장</button>
        </div>
    );
};

export default JWTRemainingTime;
